// extracted by mini-css-extract-plugin
export default {"RightPanel":"styles_RightPanel__Yh0DX"};